// Configuration for Peach Payments API
export const peachPaymentConfig = {
  entityId: import.meta.env.VITE_PEACH_PAYMENT_ENTITY_ID || '',
  authorizationBearer: import.meta.env.VITE_PEACH_PAYMENT_AUTH_BEARER || '',
  apiBaseUrl: import.meta.env.VITE_PEACH_PAYMENT_API_URL || 'https://test.oppwa.com', // Use test URL by default
  currency: import.meta.env.VITE_PEACH_PAYMENT_CURRENCY || 'ZAR',
};

// Validates if the Peach Payment configuration is properly set
export const isPeachPaymentConfigured = (): boolean => {
  return (
    !!peachPaymentConfig.entityId &&
    !!peachPaymentConfig.authorizationBearer &&
    !!peachPaymentConfig.apiBaseUrl
  );
}; 